module.exports = __webpack_public_path__ + "static/media/_DSC6555_16_9_AR.07ebb508.jpg";